module.exports = __webpack_public_path__ + "112e86c0a66918dfe788ecdccbface.png";